import React from 'react';
import styles from '../accountDetails.module.css';
import { tWithKeyAttr as t } from "../../../../i18nHelper";

interface ActiveServicesTabProps {
}

export const ActiveServicesTab: React.FC<ActiveServicesTabProps> = () => {
  return (
    <div className={styles.activeServicesContent}>
      <h2>{t("AVAILABLE_SERVICES")}</h2>
    </div>
  );
};
